/**
 * AI usage metering types (server-side gateway).
 */
export const AI_USAGE_LOG = 'AiUsageLog';
export const AI_USAGE_ROLLUP = 'AiUsageRollup';
//# sourceMappingURL=ai.js.map